import { FC } from 'react';
import { Container } from './Skeleton.styles';

export interface SkeletonProps {
	$width?: number;
	$height?: number;
	$borderRadius?: number;
}

const Skeleton: FC<SkeletonProps> = (props) => {
	return <Container {...props} />;
};

export default Skeleton;
